import { z } from 'zod';
/**
 * SVG Logo Data Schema
 * Represents an SVG logo with a single URL
 */ export const SvgLogoDataSchema = z.object({
    type: z.literal('svg'),
    svg: z.string(),
    uploadedAt: z.number()
});
/**
 * Raster Logo Data Schema
 * Represents processed raster logo data with multiple sizes and formats (WebP + PNG)
 */ export const RasterLogoDataSchema = z.object({
    type: z.literal('raster'),
    thumbnail: z.object({
        webp: z.string(),
        png: z.string()
    }),
    medium: z.object({
        webp: z.string(),
        png: z.string()
    }),
    uploadedAt: z.number()
});
/**
 * Logo Data Schema - Discriminated Union
 * Can be either SVG or Raster
 */ export const LogoDataSchema = z.discriminatedUnion('type', [
    SvgLogoDataSchema,
    RasterLogoDataSchema
]);
/**
 * SVG System Logo Data Schema
 * Represents an SVG system logo with a single URL
 */ export const SvgSystemLogoDataSchema = z.object({
    type: z.literal('svg'),
    svg: z.string(),
    uploadedAt: z.number()
});
/**
 * Raster System Logo Data Schema
 * Represents processed raster system logo data with thumbnail size only (WebP + PNG)
 */ export const RasterSystemLogoDataSchema = z.object({
    type: z.literal('raster'),
    thumbnail: z.object({
        webp: z.string(),
        png: z.string()
    }),
    uploadedAt: z.number()
});
/**
 * System Logo Data Schema - Discriminated Union
 * Can be either SVG or Raster
 */ export const SystemLogoDataSchema = z.discriminatedUnion('type', [
    SvgSystemLogoDataSchema,
    RasterSystemLogoDataSchema
]);

//# sourceMappingURL=logo.schema.js.map